








import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class UploadProgress extends Vue {

}
